import {Tooltip} from "@mui/material";
import {OpenInNew} from "@mui/icons-material";
import {grey} from "@mui/material/colors";
import {useNavigate} from "react-router-dom";

// the open-in-tool link of an anchor cell whose anchors come from the screen drawing. Navigates on
// the current page; a ctrl/cmd/shift-click is left to the browser so it can open a new tab.
export function AnchorElevationLink(props: {url: string}) {
    const nav = useNavigate();

    return (
        <Tooltip title="Open in elevation tool">
            <a href={props.url}
               onClick={e => {
                   e.stopPropagation();
                   if(e.metaKey || e.ctrlKey || e.shiftKey) return;
                   e.preventDefault();
                   nav(props.url);
               }}
               style={{color: grey["500"], display: "inline-flex", marginLeft: 4}}>
                <OpenInNew style={{fontSize: "0.9rem"}}/>
            </a>
        </Tooltip>
    );
}
